import React from 'react';
import "../../../styles/Portal.css";
import "../../../styles/querysteps.css";

const Spouse = () => {
    return <div>Spouse</div>;
}

export default Spouse;